import { Typography } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import { appLogger } from "../../utils";

const TopTenChartCommentors = (props: any) => {
  const navigate = useNavigate();
  const { UserCountsFBData, chartType } = props;
  appLogger.info({
    infoObj: {
      method: "TopTenChartCommentors",
      component: "dashboard",
      fileName: "topTenChartCommentors.tsx",
      prpos: props,
    },
  });
  let formseries: any = [];
  let formCategories: any = [];

  const count = UserCountsFBData?.countData?.uniqCountData?.total;

  const dataShow = count > 0 ? true : false;

  if (UserCountsFBData?.countData?.uniqCountData?.data) {
    formseries = Object.values(
      UserCountsFBData?.countData?.uniqCountData?.data
    );
    formCategories = Object.keys(
      UserCountsFBData?.countData?.uniqCountData?.data
    );
  }

  const barSize = () => {
    let size = "";

    if (count >= 5) {
      size = "80%";
    } else if (count >= 4) {
      size = "60%";
      return size;
    } else if (count >= 3) {
      size = "40%";
      return size;
    } else if (count >= 2) {
      size = "30%";
      return size;
    } else if (count >= 1) {
      size = "15%";
      return size;
    }

    return size;
  };

  const colorsAction = () => {
    let colors: any;

    if (chartType === "feedback") {
      colors = [
        "#3333cc",
        // "#3333cc",
        // "#3333cc",
        // "#3333cc",
        // "#3333cc",
        // "#3333cc",
        // "#3333cc",
        // "#3333cc",
        // "#3333cc",
        // "#3333cc",
      ];
    } else if (chartType === "bug") {
      colors = [
        "#fc6423",
        // "#fc6423",
        // "#fc6423",
        // "#fc6423",
        // "#fc6423",
        // "#fc6423",
        // "#fc6423",
        // "#fc6423",
        // "#fc6423",
        // "#fc6423",
      ];
    } else {
      colors = [
        "#0157ff",
        "#0157ff",
        "#0157ff",
        "#0157ff",
        "#0157ff",
        "#0157ff",
        "#0157ff",
        "#0157ff",
        "#0157ff",
        "#0157ff",
      ];
    }
    return colors;
  };

  const exportNameAction = () => {
    let name: any;

    if (chartType === "feedback") {
      name = "CuVo_Top_10_Feedback_Commenters";
    } else if (chartType === "bug") {
      name = "CuVo_Top_10_Bug_Commenters";
    } else {
      name = "CuVo_Top_10_FR_Commenters";
    }
    return name;
  };

  const state: any = {
    options: {
      tooltip: {
        custom: function (config: any) {
          return (
            `<div class="custom-tooltip" style="background: ${
              config.w.config.colors[config.dataPointIndex]
            }">` +
            "<h2 class='tooltip-title'>" +
            config.w.globals.labels[config.dataPointIndex] +
            "</h2>" +
            "<div class='tooltip-info'>" +
            config.w.globals.series[0][config.dataPointIndex] +
            "<span>" +
            `(${
              config.w.globals.series[0][config.dataPointIndex] > 0
                ? (
                    (config.w.globals.series[0][config.dataPointIndex] /
                      config.w.globals.seriesTotals[0]) *
                    100
                  ).toFixed(2)
                : 0
            }%)` +
            "</span></div>" +
            "</div>"
          );
        },
      },
      chart: {
        // events: {
        //   dataPointSelection: function (
        //     event: any,
        //     chartContext: any,
        //     config: any
        //   ) {
        //     // click: function (event: any, chartContext: any, config: any) {
        //     appLogger.info({
        //       infoObj: {
        //         method: "dataPointSelection",
        //         component: "dashboard",
        //         fileName: "topTenChartCommentors.tsx",
        //         config: config,
        //       },
        //     });

        //     const dataPointIndexValue = config.dataPointIndex;
        //     const selectedFilterLabel =
        //       config.w.globals.labels[dataPointIndexValue];
        //     const selectedFilterValue =
        //       config.w.config.series[0].data[dataPointIndexValue];
        //     appLogger.info({
        //       infoObj: {
        //         method: "dataPointSelection",
        //         component: "dashboard",
        //         fileName: "topTenChartCommentors.tsx",
        //         data: { selectedFilterLabel, selectedFilterValue },
        //       },
        //     });
        //     const test = {
        //       // name: "",
        //       // filters: [
        //       // {
        //       field: "EMAIL",
        //       operation: "contains",
        //       value: [selectedFilterLabel],
        //       // },
        //       // ],
        //       // advanceFilters: [],
        //     };
        //     navigate("/feedback", {
        //       state: {
        //         pageType:
        //           chartType === "feedback"
        //             ? "FEEDBACK"
        //             : chartType === "bug"
        //             ? "BUG_REPORT"
        //             : "FEATURE_REQUEST",
        //         ratingsClicked: test,
        //       },
        //     });
        //     props.setChartData(test);
        //   },
        // },
        type: "bar",
        toolbar: {
          export: {
            csv: {
              filename: exportNameAction(),
            },
            svg: {
              filename: exportNameAction(),
            },
            png: {
              filename: exportNameAction(),
            },
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          distributed: true,
          horizontal: true,
          barHeight: barSize(),
        },
      },
      legend: {
        show: false,
      },
      colors: colorsAction(),
      dataLabels: {
        enabled: false,
      },

      xaxis: {
        categories: formCategories,
      },
    },
  };
  const series = [
    {
      name: "Comments",
      data: formseries.length > 0 ? formseries : [1],
    },
  ];
  return (
    <>
      {dataShow ? (
        <ReactApexChart
          options={state.options}
          series={series}
          type="bar"
          height={280}
        />
      ) : (
        <Typography className="no-data">no data</Typography>
      )}
    </>
  );
};

export default TopTenChartCommentors;
